export default __webpack_public_path__ + "static/Continuous Integration 7-481862ef596a3a365c5d7c32d2939745.png";